import React from 'react';
import {Box, IconButton, ListItemText, SvgIcon} from '@mui/material';
import {
    StyledFileManagerMenuItem,
    StyledFileManagerListItemText,
    StyledFileManagerErrorListItemText,
    StyledFileManagerCompletedListItemText,
    StyledFileManagerIconButton,
} from '../styles/mui_styles';

const ExportItem = ({ item, fileName }) => {
    const isCompleted = item.status === 'Completed';

    return (
        <StyledFileManagerMenuItem
            sx={{ fontSize: '0.75rem' }}
            component={isCompleted ? 'a' : 'div'}
            href={isCompleted ? item.url : undefined}
            target={isCompleted ? '_blank' : undefined}
            rel={isCompleted ? 'noopener noreferrer' : undefined}
            disabled={!isCompleted}
        >
            {item.status === 'InProgress' ? (
                <Box className="file_manager-menu_block--box">
                    <StyledFileManagerListItemText
                        primary={fileName}
                        primaryTypographyProps={{ fontSize: '0.75rem' }}
                    />
                    <IconButton disabled sx={{ ml: 2 }}>
                        <SvgIcon className="loading_icon" />
                    </IconButton>
                </Box>
            ) : item.status === 'Failed' ? (
                <Box className="file_manager-menu_block--box">
                    <StyledFileManagerErrorListItemText
                        primary={fileName}
                        primaryTypographyProps={{ fontSize: '0.75rem' }}
                    />
                    <IconButton disabled sx={{ ml: 2 }}>
                        <SvgIcon className="errors_icon" />
                    </IconButton>
                </Box>
            ) : (
                <Box className="file_manager-menu_block--box">
                    <StyledFileManagerCompletedListItemText
                        primary={fileName}
                        primaryTypographyProps={{ fontSize: '0.75rem' }}
                    />
                    <StyledFileManagerIconButton
                        href={item.url}
                        target="_blank"
                        sx={{ ml: 2 }}
                    >
                        <SvgIcon className="downloads_icon" />
                    </StyledFileManagerIconButton>
                </Box>
            )}
        </StyledFileManagerMenuItem>
    );
};

export default ExportItem;
